// extracted by mini-css-extract-plugin
module.exports = {"root":"MessagesList_root__23a1h","header":"MessagesList_header__1_ClJ","chat":"MessagesList_chat__3DjWB"};